[
  {
    "id": "SR-B6P-SMORGENS-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "schrijfwijze",
    "subSkill": "s_genitief",
    "familyId": "SR-S-GENITIEF",
    "conceptId": "genitive_s_apostrophe",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["'s morgens", "smorgens", "s'morgens", "s morgens"],
    "correctAnswer": 0,
    "explanation": "Het is een afkorting van 'des morgens'. De apostrof staat op de plek van 'de': 's morgens. Let op de spatie tussen 's en morgens.",
    "distractorExplanations": {
      "1": "Zonder apostrof en spatie is het fout. Het is een afkorting: 's morgens.",
      "2": "De apostrof staat vóór de 's', niet erna. Het is 's, niet s'.",
      "3": "De apostrof ontbreekt. Zonder apostrof weet je niet dat het een afkorting is."
    }
  },
  {
    "id": "SR-B6P-ZEEEN-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "schrijfwijze",
    "subSkill": "trema",
    "familyId": "SR-TREMA-MEERVOUD",
    "conceptId": "trema_plural_vowel_collision",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord heeft een trema?",
    "options": ["zeeën", "zeeen", "zeen", "zeeén"],
    "correctAnswer": 0,
    "explanation": "Zee + en = zeeën. Het trema (¨) voorkomt dat je 'zeen' leest. De puntjes laten zien dat de 'e' apart uitgesproken wordt.",
    "distractorExplanations": {
      "1": "Zonder trema zou je 'zeeen' als één klank lezen. Het trema is nodig.",
      "2": "Er missen letters. Het meervoud van zee is zee-en, met trema: zeeën.",
      "3": "Dit is een accent aigu (é), geen trema (ë). Een trema heeft twee puntjes."
    }
  },
  {
    "id": "SR-B6P-CADEAU-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_eau",
    "familyId": "SR-WEETWOORD-EAU-CADEAU",
    "conceptId": "french_eau_ending",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["cadeau", "kado", "cadea", "cado"],
    "correctAnswer": 0,
    "explanation": "'Cadeau' is een Frans leenwoord. Je schrijft '-eau' aan het eind. Dit moet je uit je hoofd leren.",
    "distractorExplanations": {
      "1": "'Kado' is spreektaal maar niet de standaardspelling. Op school schrijf je 'cadeau'.",
      "2": "De uitgang is '-eau', niet '-ea'. Er ontbreekt een 'u'.",
      "3": "Het begint met 'ca-', niet 'ka-', en de uitgang is '-eau', niet '-o'."
    }
  },
  {
    "id": "SR-B6P-CENT-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_c",
    "familyId": "SR-WEETWOORD-C-ALS-S",
    "conceptId": "c_as_s_sound",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["cent", "sent", "cend", "send"],
    "correctAnswer": 0,
    "explanation": "Je hoort een 's', maar schrijft een 'c'. De 'c' klinkt als 's' vóór een 'e' of 'i'. Cent, circus, citroen.",
    "distractorExplanations": {
      "1": "Je hoort een 's', maar schrijft een 'c'. Dit is een spellingregel voor de letter 'c'.",
      "2": "Het eindigt op '-nt', niet op '-nd'. Verleng: centen (je hoort een 't').",
      "3": "Dubbel fout: het begint met 'c' (niet 's') en eindigt op 't' (niet 'd')."
    }
  },
  {
    "id": "SR-B6P-COLA-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_c",
    "familyId": "SR-WEETWOORD-C-ALS-K",
    "conceptId": "c_as_k_sound",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["cola", "kola", "colla", "coola"],
    "correctAnswer": 0,
    "explanation": "Je hoort een 'k', maar schrijft een 'c'. De 'c' klinkt als 'k' vóór een 'a', 'o' of 'u'. Cola, cactus, computer.",
    "distractorExplanations": {
      "1": "Je hoort een 'k', maar schrijft een 'c'. Dit is een leenwoord.",
      "2": "Geen dubbele 'l'. Het is co-la, niet col-la.",
      "3": "Geen dubbele 'o'. De 'o' is al lang in een open lettergreep (co-la)."
    }
  },
  {
    "id": "SR-B6P-SAVONDS-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "schrijfwijze",
    "subSkill": "s_genitief",
    "familyId": "SR-S-GENITIEF",
    "conceptId": "genitive_s_apostrophe",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["'s avonds", "savonds", "s'avonds", "s avonds"],
    "correctAnswer": 0,
    "explanation": "Net als 's morgens: het is een afkorting van 'des avonds'. Apostrof vóór de 's', dan een spatie: 's avonds.",
    "distractorExplanations": {
      "1": "Er moet een apostrof en spatie bij: 's avonds.",
      "2": "De apostrof staat vóór de 's', niet erna.",
      "3": "De apostrof ontbreekt. Het is 's avonds."
    }
  },
  {
    "id": "SR-B6P-IDEEEN-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "schrijfwijze",
    "subSkill": "trema",
    "familyId": "SR-TREMA-MEERVOUD",
    "conceptId": "trema_plural_vowel_collision",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woord heeft een trema?",
    "options": ["ideeën", "ideeen", "ideen", "ideeèn"],
    "correctAnswer": 0,
    "explanation": "Idee + en = ideeën. Het trema voorkomt dat je 'ideeen' als drie lettergrepen leest in plaats van vier (i-dee-ën).",
    "distractorExplanations": {
      "1": "Zonder trema is de uitspraak onduidelijk. Het trema is verplicht.",
      "2": "Er missen letters. Het is idee + en = ideeën.",
      "3": "Dit is een accent grave (è), geen trema (ë). Een trema heeft twee puntjes."
    }
  },
  {
    "id": "SR-B6P-CIRCUS-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_c",
    "familyId": "SR-WEETWOORD-C-DUBBEL",
    "conceptId": "c_double_sound_word",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["circus", "sirkus", "cirkus", "sircus"],
    "correctAnswer": 0,
    "explanation": "'Circus' schrijf je met twee keer een 'c'. De eerste 'c' klinkt als 's' (voor 'i'), de tweede 'c' klinkt als 'k' (voor 'u').",
    "distractorExplanations": {
      "1": "Beide c's zijn vervangen. In het Nederlands schrijven we 'circus' met twee c's.",
      "2": "Alleen de eerste 'c' is vervangen door 'k'. Maar 'c' voor 'i' klinkt als 's', niet als 'k'.",
      "3": "Alleen de tweede 'c' is vervangen door 's'. Maar 'c' voor 'u' klinkt als 'k'."
    }
  },
  {
    "id": "SR-B6P-BUREAU-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_eau",
    "familyId": "SR-WEETWOORD-EAU-BUREAU",
    "conceptId": "french_eau_ending",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["bureau", "buro", "burea", "burow"],
    "correctAnswer": 0,
    "explanation": "'Bureau' is een Frans leenwoord met '-eau'. Net als cadeau en niveau.",
    "distractorExplanations": {
      "1": "'Buro' is spreektaal maar niet de standaardspelling. Op school schrijf je 'bureau'.",
      "2": "De uitgang is '-eau', niet '-ea'. Er ontbreekt een 'u'.",
      "3": "De uitgang is '-eau', niet '-ow'. Dit is geen Engels woord."
    }
  },
  {
    "id": "SR-B6P-COMPUTER-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_c",
    "familyId": "SR-WEETWOORD-C-ALS-K",
    "conceptId": "c_as_k_sound",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["computer", "komputer", "compjuter", "komputor"],
    "correctAnswer": 0,
    "explanation": "'Computer' schrijf je met een 'c'. Het is een Engels leenwoord. De 'c' klinkt als 'k' (voor 'o').",
    "distractorExplanations": {
      "1": "Je hoort 'k', maar schrijft 'c'. Engelse leenwoorden behouden hun spelling.",
      "2": "Er zit geen 'j' in dit woord. Het is com-pu-ter.",
      "3": "Het begint met 'c' (niet 'k') en eindigt op '-er' (niet '-or')."
    }
  },
  {
    "id": "SR-B6P-GEEIST-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "schrijfwijze",
    "subSkill": "trema",
    "familyId": "SR-TREMA-VOORVOEGSEL",
    "conceptId": "trema_prefix_vowel_collision",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord heeft een trema?",
    "options": ["geëist", "geeist", "geiest", "ge-eist"],
    "correctAnswer": 0,
    "explanation": "Na het voorvoegsel 'ge-' komt een 'e'. Om verwarring te voorkomen, zet je een trema: geëist. Zo weet je dat het ge-eist is.",
    "distractorExplanations": {
      "1": "Zonder trema zou je 'gee-ist' lezen. Het trema is nodig.",
      "2": "De letters staan in de verkeerde volgorde. Het is ge-eist, niet ge-iest.",
      "3": "Een streepje is niet de standaard oplossing. We gebruiken een trema."
    }
  },
  {
    "id": "SR-B6P-SMIDDAGS-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "schrijfwijze",
    "subSkill": "s_genitief",
    "familyId": "SR-S-GENITIEF",
    "conceptId": "genitive_s_apostrophe",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["'s middags", "smiddags", "s'middags", "s middags"],
    "correctAnswer": 0,
    "explanation": "Net als 's morgens en 's avonds: apostrof vóór de 's', dan een spatie. 's middags.",
    "distractorExplanations": {
      "1": "Er moet een apostrof en spatie bij: 's middags.",
      "2": "De apostrof staat vóór de 's', niet erna.",
      "3": "De apostrof ontbreekt."
    }
  },
  {
    "id": "SR-B6P-CITROEN-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_c",
    "familyId": "SR-WEETWOORD-C-ALS-S",
    "conceptId": "c_as_s_sound",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["citroen", "sitroen", "citruen", "sitruen"],
    "correctAnswer": 0,
    "explanation": "'Citroen' schrijf je met een 'c'. De 'c' klinkt als 's' vóór een 'i'.",
    "distractorExplanations": {
      "1": "De 'c' klinkt als 's', maar je schrijft 'c'. Dit is een spellingregel.",
      "2": "Het is 'citroen' met 'oe', niet met 'ue'.",
      "3": "Dubbel fout: het begint met 'c' en heeft 'oe', niet 'ue'."
    }
  },
  {
    "id": "SR-B6P-NIVEAU-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_eau",
    "familyId": "SR-WEETWOORD-EAU-NIVEAU",
    "conceptId": "french_eau_ending",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["niveau", "nivo", "nivea", "nivu"],
    "correctAnswer": 0,
    "explanation": "'Niveau' is een Frans leenwoord. Je hoort 'nivo', maar schrijft '-eau'. Net als cadeau en bureau.",
    "distractorExplanations": {
      "1": "'Nivo' is een verouderde spelling. De standaardspelling is 'niveau'.",
      "2": "'Nivea' is een merknaam, geen correct Nederlands woord.",
      "3": "De uitgang is '-eau', niet '-u'."
    }
  },
  {
    "id": "SR-B6P-CAKE-V01",
    "module": "SpellingRegel",
    "difficulty": 102,
    "difficultyTier": 2,
    "levelCode": "B6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_c",
    "familyId": "SR-WEETWOORD-C-ALS-K",
    "conceptId": "c_as_k_sound",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["cake", "keek", "caik", "kaak"],
    "correctAnswer": 0,
    "explanation": "'Cake' schrijf je met een 'c'. Het is een Engels leenwoord. De 'c' klinkt als 'k'.",
    "distractorExplanations": {
      "1": "'Keek' is de verleden tijd van 'kijken'. 'Cake' (gebak) schrijf je met 'c'.",
      "2": "De spelling is 'cake', niet 'caik'. Het is een Engels woord.",
      "3": "'Kaak' is een lichaamsdeel. 'Cake' (gebak) schrijf je met 'c' en 'ke'."
    }
  }
]